import { createSelector } from "reselect";
const selector = (state) => state.disputes;

export default createSelector([selector], (data) => data);